module.exports = __webpack_public_path__ + "static/metaImage-6eb86fad7c09ed6e492e668e1d9302ae.jpg";